import React, { useCallback, FC } from 'react';
import SockJsClient from 'react-stomp';
import cookie from 'cookie';
import { useNotifications } from 'utils/hooks/data/useNotifications';
import { useTaskNotifications } from 'utils/hooks/data/useTasks';
import { getSessionConfigForHTTPHeaders } from 'utils/authSessionForCode/sessionConfig';
import { useLoggedInUser } from 'src/utils/hooks/useLoggedInUser';
import { NotificationWebSocketMessage } from './Websocket.types';

export const WebsocketComponent: FC<React.PropsWithChildren<unknown>> = () => {
  const user = useLoggedInUser();

  const { handleNotificationsWSUpdate } = useNotifications();
  const { handleTasksWSUpdate } = useTaskNotifications();

  const handleNotificationUpdate = useCallback(
    (msg: NotificationWebSocketMessage) => {
      if (msg.payload.type.includes('TASK') || msg.payload.resourceLocation?.includes('api/task')) {
        handleTasksWSUpdate();
      } else {
        // Task Resolved Notifications shouldn't be included in the notifications
        // They only clog up the notification list
        handleNotificationsWSUpdate(msg.payload);
      }
    },
    [handleNotificationsWSUpdate, handleTasksWSUpdate]
  );

  if (!user?.person?.personUid) {
    return null;
  }

  const headers = getSessionConfigForHTTPHeaders();
  const xsrfCookieValue = cookie.parse(document.cookie)['XSRF-TOKEN'];
  if (xsrfCookieValue) {
    headers['X-XSRF-TOKEN'] = xsrfCookieValue;
  }

  const socketUrl = `https://${window.location.hostname}:${window.location.port}/events`;
  return (
    <SockJsClient
      url={socketUrl}
      topics={[`/user/${user.uid}/self`]}
      headers={headers}
      heartbeat={60000}
      options={{ transports: ['websocket'] }}
      onMessage={handleNotificationUpdate}
    />
  );
};
